import { createContext, useContext } from 'react';
import type { Editor } from '@tiptap/react';
import { useEditorState } from '@tiptap/react';

interface IEditorContext {
   editor: Editor;
   preset: string;
}

const editorContextDefaults: IEditorContext = {
   // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'Editor'.
   editor: null,
   preset: '',
};

export const EditorContext = createContext<IEditorContext>(editorContextDefaults);

export const useEditorContext = () => useContext(EditorContext);

/**
 * Subscribe a component to a slice of editor state. The selector re-runs on
 * every transaction and the component re-renders only when its result
 * changes (deep equality), so toolbar buttons stop re-rendering per
 * keystroke. Returns null while there is no live editor: v3 nulls the
 * command manager on destroy, so a selector calling can() on a destroyed
 * editor would throw.
 */
export function useEditorSelector<T>(selector: (editor: Editor) => T): T | null {
   const { editor } = useEditorContext();
   return useEditorState({
      editor,
      selector: ({ editor: current }) =>
         current && !current.isDestroyed ? selector(current) : null,
   });
}
